import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/speech-overlay.png'


const _withScopeId = n => (_pushScopeId("data-v-83ec2746"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "record-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { id: "header-title" }, "Ga klaar staan", -1))
const _hoisted_3 = { id: "record-page__container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "live-feed-overlay",
  src: _imports_0
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_webcam_live_feed = _resolveComponent("webcam-live-feed")!
  const _component_progress_bar = _resolveComponent("progress-bar")!
  const _component_submit_button = _resolveComponent("submit-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _hoisted_2,
      _createElementVNode("p", {
        id: "header-subtitle",
        class: _normalizeClass({active: _ctx.countdownActive})
      }, "De opname begint over " + _toDisplayString(_ctx.currectActveRemaingingTimeInSeconds) + " seconden", 3),
      _createElementVNode("p", {
        id: "header-subtitle",
        class: _normalizeClass({active: _ctx.recordingActive})
      }, "De opname stopt over " + _toDisplayString(_ctx.currectActveRemaingingTimeInSeconds) + " seconden", 3)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_webcam_live_feed, {
        id: "live-feed",
        width: 768,
        height: 1360,
        framerate: 60,
        onReady: _ctx.onVideoReady
      }, null, 8, ["onReady"]),
      (_ctx.countdownActive)
        ? (_openBlock(), _createBlock(_component_progress_bar, {
            key: 0,
            id: "progress-bar",
            duration: _ctx.timerDuration
          }, null, 8, ["duration"]))
        : _createCommentVNode("", true),
      (_ctx.recordingActive)
        ? (_openBlock(), _createBlock(_component_progress_bar, {
            key: 1,
            id: "progress-bar",
            duration: _ctx.recordDuration
          }, null, 8, ["duration"]))
        : _createCommentVNode("", true),
      _hoisted_4,
      (!_ctx.countdownActive && !_ctx.recordingActive)
        ? (_openBlock(), _createBlock(_component_submit_button, {
            key: 2,
            id: "submit-button",
            onClick: _ctx.startRecordTimer
          }, {
            default: _withCtx(() => [
              _createTextVNode("Start")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_ctx.recordingActive)
        ? (_openBlock(), _createBlock(_component_submit_button, {
            key: 3,
            id: "submit-button",
            onClick: _ctx.stopRecording
          }, {
            default: _withCtx(() => [
              _createTextVNode("Stop")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ])
  ]))
}